import { useEnvironmentContainer } from '@jira/polaris__component-environment-container/src/useEnvironmentContainer.tsx';
import { useIsCollectionView } from './useIsCollectionView.tsx';
import { useCanEditCollection } from './useCanManageViews.tsx';
import { useHasPermissionsWithSiteAdmin } from './useHasPermissionsWithSiteAdmin.tsx';

export type ProjectId = string;

// if ommitted, Permission is true for all projects
export type CanEditFieldsProps = {
	// Permission is true for a specific project
	projectId?: ProjectId;
};

export const useCanEditFields = (options?: CanEditFieldsProps): boolean => {
	const hasAccess = useHasPermissionsWithSiteAdmin({
		permissionKeys: ['ADMINISTER_PROJECTS', 'EDIT_ISSUE_LAYOUT'],
		allowedForSiteAdmin: false,
		projectIds: options?.projectId ? [options.projectId] : undefined,
	});

	const [isCollectionView] = useIsCollectionView();
	const collectionUUID = useEnvironmentContainer()?.id ?? '';
	const canEditCollection = useCanEditCollection({
		collectionUUID,
	});

	return isCollectionView ? canEditCollection : hasAccess;
};
